import React from "react";

import { ReactComponent as GoogleSheetsIcon } from "../assets/icons/google-sheets.svg";
import { AppIdType } from "../_utils/constants";
import {
  PUBLISHED,
  ERROR_STATUSES,
  SCHEDULED_STATUSES,
  PROCESSING_STATUSES,
} from "../_constants/PostStatus";
import { SourceTypes } from "../_actions/types";
import {
  FaFacebook,
  FaGoogleDrive,
  FaInstagram,
  FaLinkedin,
  FaShopify,
} from "react-icons/fa";
import { getMimeType } from "../_utils/mimeType";

const getMimeTypeByFileUrl = (url, getExt = () => "") => {
  try {
    const urlObject = new URL(url);
    const name = urlObject.pathname.split("/").pop();
    const ext =
      name.indexOf(".") > -1 ? name.split(".").pop() : getExt(urlObject);

    return getMimeType(ext) || "";
  } catch (e) {
    return "";
  }
};

export const getProjectPostEditorPayload = ({ file }) => {
  const mimeType = getMimeTypeByFileUrl(file);
  const data = {
    external: true,
    mimeType,
    url: file,
    thumbUrl: file,
    credits: "",
  };

  if (mimeType.split("/")[0] === "video") {
    data.thumbTime = 0;
    data.converted = true;
  }

  return data;
};

export const getAssetPostEditorPayload = ({
  content: { meta },
  payload: { src, cover },
}) => {
  const mimeType = getMimeTypeByFileUrl(src);
  const data = {
    external: !/\/planner\//.test(src),
    mimeType: getMimeTypeByFileUrl(src),
    url: src,
    thumbUrl: cover,
    credits: "",
  };

  if (mimeType.split("/")[0] === "video") {
    data.thumbTime = 0;
  }

  return data;
};

export const getImagePostEditorPayload = ({
  content: { url, previewURL, meta, source },
  payload: { src, cover },
}) => {
  const username = meta?.username || meta?.user?.name || meta?.user || "";
  const credits =
    username || meta?.source
      ? `Image ${username ? `by ${username}` : ""} from ${
          source ? `${source}` : ""
        }`
      : "";

  if (source === SourceTypes.UNSPLASH) {
    return {
      external: true,
      mimeType: getMimeTypeByFileUrl(src, (urlObject) => {
        return urlObject.searchParams.get("fm");
      }),
      url: src,
      thumbUrl: cover,
      credits,
    };
  }

  return {
    external: true,
    mimeType: getMimeTypeByFileUrl(src),
    url: src,
    thumbUrl: cover,
    credits,
  };
};

// export const getVideoPostEditorPayload = ({ payload }) => ({
//   external: true,
//   mimeType: getMimeTypeByFileUrl(payload.src),
//   url: payload.src,
//   thumbUrl: payload.cover,
//   thumbTime: 0,
//   credits: "",
// });

export const getGiphyPostEditorPayload = ({
  content: { meta },
  payload: { src, cover },
}) => ({
  external: true,
  mimeType: getMimeTypeByFileUrl(src),
  url: src,
  thumbUrl: cover,
  credits: "",
});

export const setPostEditorDragData = (event, data) => {
  event.dataTransfer.setData(
    "application/json",
    JSON.stringify({
      ...data,
      from: "media-panel",
    })
  );
};

export function renderChannelIcon(app_id) {
  switch (app_id) {
    case AppIdType.INSTAGRAM_BUSINESS:
      return <FaInstagram />;
    case AppIdType.FACEBOOK_APP:
      return <FaFacebook />;
    case AppIdType.GOOGLE_DRIVE:
      return <FaGoogleDrive />;
    case AppIdType.GOOGLE_SHEETS:
      return <GoogleSheetsIcon />;
    case AppIdType.SHOPIFY_APP:
      return <FaShopify />;
    case AppIdType.LINKEDIN_APP:
      return <FaLinkedin />;
    default:
      break;
  }
}

export function getPostStatusTypeLabel(status) {
  if (PUBLISHED === status) {
    return "posts.published";
  }

  if (ERROR_STATUSES.includes(status)) {
    return "posts.failed";
  }

  if (SCHEDULED_STATUSES.includes(status)) {
    return "posts.scheduled";
  }

  if (PROCESSING_STATUSES.includes(status)) {
    return "posts.processing";
  }
}
